import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78093f15&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78093f15')) {
      api.createRecord('78093f15', component.options)
    } else {
      api.reload('78093f15', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=78093f15&", function () {
      api.rerender('78093f15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier-source/index.vue"
export default component.exports